var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _ellipse, _ellipse2, _path40, _path41, _ellipse3, _ellipse4, _path42, _path43, _path44;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 28.3 13.1-7.5 47.9 24-14 7z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M5.3 25v3.8l2.5-1.3v-3.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 25v3.8l2.5-1.3v-3.7z",
    opacity: 0.39
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M46.2 42.9c-.7-.4-1.4-.4-1.9-.2l-1.4.7c-.6.2-.9.8-.9 1.6 0 1.5 1.3 3.4 2.8 4.2.8.4 1.5.4 2 .2 0 0 1.4-.7 1.5-.8.5-.3.7-.8.7-1.5 0-1.6-1.3-3.5-2.8-4.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8 49.3c.2-.1 1.4-.7 1.5-.7.5-.3.7-.8.7-1.5 0-.6-.2-1.3-.5-1.9l-1.4.7c.3.6.5 1.3.5 1.9 0 .7-.3 1.3-.8 1.5z",
    opacity: 0.39
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M46.9 47.4c0 1.2-.9 1.6-2.1 1s-2.1-2-2.1-3.2.9-1.6 2.1-1 2.1 2 2.1 3.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48.4c-1.2-.6-2.1-2-2.1-3.2 0-.6.2-1 .6-1.2-.5.1-.8.6-.8 1.2 0 1.2.9 2.6 2.1 3.2.6.3 1.1.3 1.5.1-.4.2-.8.1-1.3-.1z",
    opacity: 0.15
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M45.8 46.7c0 .5-.4.7-.9.4-.5-.2-.9-.8-.9-1.3s.4-.7.9-.4c.6.2.9.8.9 1.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 46.7c0 .5-.4.7-.9.4-.5-.2-.9-.8-.9-1.3s.4-.7.9-.4c.6.2.9.8.9 1.3z",
    opacity: 0.39
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M45.7 46.8c0 .5-.4.7-.9.4-.5-.2-.9-.8-.9-1.3s.4-.7.9-.4c.5.2.9.8.9 1.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6 47.8c0 1.5-1.3 2.2-2.8 1.4S42 46.5 42 45s1.3-2.2 2.8-1.4 2.8 2.6 2.8 4.2z",
    opacity: 0.06
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M9.7 24.6c-.7-.4-1.4-.4-1.9-.2l-1.4.7c-.5.2-.9.8-.9 1.6 0 1.5 1.3 3.4 2.8 4.2.8.4 1.5.4 2 .2 0 0 1.4-.7 1.5-.8.5-.3.7-.8.7-1.5 0-1.5-1.3-3.4-2.8-4.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 31.1c.2-.1 1.4-.7 1.5-.7.5-.3.7-.8.7-1.5 0-.6-.2-1.3-.5-1.9l-1.4.7c.3.6.5 1.3.5 1.9 0 .7-.3 1.2-.8 1.5z",
    opacity: 0.39
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M10.4 29.2c0 1.2-.9 1.6-2.1 1s-2.1-2-2.1-3.2.9-1.6 2.1-1 2.1 2 2.1 3.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 30.1c-1.2-.6-2.1-2-2.1-3.2 0-.6.2-1 .6-1.2-.5.1-.8.6-.8 1.2 0 1.2.9 2.6 2.1 3.2.6.3 1.1.3 1.5.1-.4.2-.8.2-1.3-.1z",
    opacity: 0.15
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M9.4 28.5c0 .5-.4.7-.9.4-.5-.2-.9-.8-.9-1.3s.4-.7.9-.4c.5.2.9.8.9 1.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 28.5c0 .5-.4.7-.9.4-.5-.2-.9-.8-.9-1.3s.4-.7.9-.4c.5.2.9.8.9 1.3z",
    opacity: 0.39
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M9.2 28.5c0 .5-.4.7-.9.4s-.9-.8-.9-1.3.4-.7.9-.4.9.9.9 1.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 29.5c0 1.5-1.3 2.2-2.8 1.4-1.5-.8-2.8-2.7-2.8-4.2s1.3-2.2 2.8-1.4c1.5.8 2.8 2.7 2.8 4.2z",
    opacity: 0.06
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#06547A",
    d: "M17 1 3 8v15.3l38 19L55 35V20z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M3 22v2l38 19v-2zM55 34v2l-14 7v-2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8v16l38 19V27z",
    opacity: 0.06
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20v16l-14 7V27z",
    opacity: 0.39
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "m62 28-6-3-14 7v11.3c0 .3.4.5.7.3 1.2-1 3.3-.3 4.8 1.5.9 1.1 1.3 2.3 1.3 3.3l1.2.6 14-7v-8l-2-6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#39C",
    d: "m50.4 40.5-1.7-5c-.1-.2 0-.3.2-.4l12.5-6.2c.2-.1.4 0 .5.2l1.6 4.7c.1.2 0 .3-.2.4l-12.4 6.5c-.2.1-.5 0-.5-.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m52.7 33.2 8.6-4.3c.2-.1.4 0 .5.2l1.5 4.4-10.6-.3z",
    opacity: 0.15
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "m63.4 33.8-.1-.3c0 .2 0 .3-.2.4l-12.4 6.5c-.2.1-.4 0-.5-.2l.1.3c.1.2.3.3.5.2l12.4-6.5c.2-.1.3-.2.2-.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m53.5 40 7-3.5v5.8l-7 3.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "m54 45 6-3v-4.7l-6 3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M64 42v-2l-14 7v2zM48 48l2 1v-2l-2-1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M54 45v1l6-3v-1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#39C",
    d: "m47.5 35.3-3.8-1.9c-.1-.1-.3 0-.3.2v3c0 .2.1.4.3.4l1.3.7c.1.1.2.1.3.2l1.3 1.6h.1l2.2 1.1c.1.1.3-.1.2-.2l-1.7-5c.2 0 .2-.1.1-.1z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m49.3 40.3-2-1h-.1l-1.3-1.6c-.1-.1-.2-.2-.3-.2l-1.3-.7c-.2-.1-.3-.2-.3-.4v-2.9l-.2-.1c-.1-.1-.3 0-.3.2v3c0 .2.1.4.3.4l1.3.7c.1.1.2.1.3.2l1.3 1.6h.1l2.2 1.1c.2.1.3 0 .3-.3z",
    opacity: 0.15
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M50 45v2l-.5-.2v-2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M54 41v.3l6-3V38zM54 42v.3l6-3V39zM54 43v.3l6-3V40zM54 44v.3l6-3V41z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M43.5 38.3v.5l1 .5v-.5z",
    opacity: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m44.5 39.5-1-.5v-.2l1 .5z",
    opacity: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M57.5 33.9c-.1-.1-.2-.1-.3 0l-3.8 4.3c-.1.1-.1.2 0 .3s.2.1.3 0l1-1.2v1h.3V37l2.5-2.9c.1 0 .1-.2 0-.2zM61.1 31.9c-.1-.1-.2-.1-.3 0L57 36.2c-.1.1-.1.2 0 .3.1.1.2.1.3 0l.9-1v1.1h.3v-1.4l2.6-3c.1-.1.1-.2 0-.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m62 41 2-1v-2l-1 .5c-.6.3-1 .9-1 1.6v.9z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.7,
    cy: 39.5,
    fill: "#2D3134",
    opacity: 0.3,
    rx: 0.8,
    ry: 0.5,
    transform: "rotate(129.144 62.714 39.544)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.2,
    cy: 39.5,
    fill: "#2D3134",
    opacity: 0.3,
    rx: 0.8,
    ry: 0.5,
    transform: "rotate(129.144 63.215 39.544)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m62 41 2-1v-2z",
    opacity: 0.3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m50 47 2-1v-.9c0-.5-.5-.8-1-.6l-1 .5v2z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.2,
    cy: 45.5,
    fill: "#2D3134",
    opacity: 0.3,
    rx: 0.8,
    ry: 0.5,
    transform: "rotate(129.144 51.215 45.544)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.7,
    cy: 45.5,
    fill: "#2D3134",
    opacity: 0.3,
    rx: 0.8,
    ry: 0.5,
    transform: "rotate(129.144 50.715 45.544)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m50 47 2-1-2-1z",
    opacity: 0.3
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m48 35-6-3v11.3c0 .3.4.5.7.3 1.2-1 3.3-.3 4.8 1.5.3.3.5.6.6 1L48 46v2l2 1v-8l-2-6z",
    opacity: 0.06
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m62 28-14 7 2 6v8l14-7v-8z",
    opacity: 0.39
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.af2a1d85dfe31a76e9bdfe1c008b2484.svg";
export { ForwardRef as ReactComponent };